import { Component, EventEmitter, input, InputSignal, Output } from '@angular/core';
import { DepositType } from "@modules/universal-billing/contract/contract.enums";
import { LocalizedDatePipe } from '@shared/pipes/localized-date.pipe';
import { MoneyFormatPipe } from '@common/pipe/money-format.pipe';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-deposit-of-contract-details',
  standalone: true,
  imports: [
    LocalizedDatePipe,
    MoneyFormatPipe,
    TranslatePipe
  ],
  templateUrl: './deposit-of-contract-details.component.html',
  styleUrl: './deposit-of-contract-details.component.scss'
})
export class DepositOfContractDetailsComponent {
  data: InputSignal<any> = input();
  @Output() edit = new EventEmitter();

  onEdit(): void {
    this.edit.emit();
  }
  protected readonly DepositType = DepositType;
}
